import { H2, VStack } from '@montel/montelpro-shared-components-v2';
import { FunctionComponent, useEffect, useState } from 'react';
import { AdminAccountTable } from './AdminAccountTable/AdminAccountTable';
import { InviteAdminForm } from './InviteAdminForm/InviteAdminForm';
import { AdminAccount } from '../../../../domain/account/interfaces/AdminAccount';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { ADMIN_ACCOUNT_API_ROUTE } from 'apiRoutes';
import { AdminRole } from 'domain/account/enums/AdminRole';
import { AccessControl } from 'components/common/AccessControl/AccessControl';

export const AdminAccountsPage: FunctionComponent = () => {
	const [users, setUsers] = useState<AdminAccount[]>([]);
	const { data, status } = useGetOnMount(
		`${ADMIN_ACCOUNT_API_ROUTE}/GetAdminList`,
	);

	const onAdminCreated = (admin: AdminAccount) => {
		setUsers([...users, admin]);
	};

	useEffect(() => {
		data && setUsers(data);
	}, [data]);

	return (
		<VStack fullWidth gap="xl">
			<AccessControl allowedRoles={[AdminRole.SUPER_ADMIN]}>
				<InviteAdminForm onSuccess={onAdminCreated} />
			</AccessControl>
			<AdminAccountTable users={users} status={status} />
		</VStack>
	);
};
